import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import ButtonComponent from "@components/Theme/Button/Button"
import {SubMenuModuleType} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import clsx from "clsx"
import {useRouter} from "next/router"
import React from "react"

import Typography, {Size, Variant} from "../Typography/Typography"
import checkIfLinkIsCurrent from "../utils/checkIfLinkIsCurrent"

import styles from "./PageSubNavigation.module.scss"

type Props = {
	data: SubMenuModuleType
	withCurve?: boolean
}

const PageSubNavigation = (props: Props) => {
	const router = useRouter()

	return (
		<section className={clsx(props.withCurve ? styles.withCurve : "")}>
			<div className={`${styles.mainContainer}`}>
				<ContainerWrapper className={styles.subheaderBox}>
					<div className={styles.ItemBoxDefault}>
						{props.data?.links?.map((link, index) => {
							const {current} = checkIfLinkIsCurrent(
								router.asPath,
								link.link,
								[],
								{strict: true},
							)
							return (
								<ButtonComponent
									key={`sublinkindex${index}`}
									buttonType={"text"}
									link={link.link}
									className={`${
										current ? styles.active : ""
									}`}
									size={"small"}
									scroll={false}
									asLink
								>
									<Typography
										content={link.title}
										fontWeight={500}
										size={Size.XS}
										style={{
											whiteSpace: "nowrap",
										}}
										variant={Variant.Paragraph}
										noPadding
									/>
								</ButtonComponent>
							)
						})}
					</div>
				</ContainerWrapper>
			</div>
		</section>
	)
}

export default PageSubNavigation
